import React, { useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { isShowTopOffersSelector, toggleTopOffersSelector, useStore } from '../hooks/useIMCState';
import Checkbox from '../../../elements/Checkbox';

const CardControl = ({ label = 'cmp-interactive-map-card-control-label', ...rest }: $TSFixMe) => {
  const isShowTopOffers = useStore(isShowTopOffersSelector);
  const toggleTopOffers = useStore(toggleTopOffersSelector);
  const { translate } = useContext(Context);

  return (
    <Checkbox
      {...rest}
      label={translate(label, 'Show top offers')}
      onChange={() => toggleTopOffers(!isShowTopOffers)}
      isChecked={isShowTopOffers}
    />
  );
};

export default CardControl;
